import { UseGetDep } from './type';
import { useEffect, useState } from 'react';
import { getModuleRecordList } from "@/common/asset-apis/assetModel";

export const useGetDep: UseGetDep = ({ FetchAPI }) => {
  const [depTreeData, setTreeData] = useState<any[]>([]);
  const [treeType, setTreeType] = useState<string>('组织');

  const setMenuData = (data: any) : any[] => {
    const result = data.map((item:any) => {
      if (item.children?.length > 0) {
        const children = setMenuData(item.children)
        return {
          label: item.name,
          key: item.number,
          // onTitleClick: clickMenu,
          children
        }
      }
      return {
        label: item.name,
        key: item.number,
      }
    })
    return result
  }

  const turnTresData = (data:any, result:any[], pId: string| number) => {
    for (const item of data) {
      if (item.superior_number === pId) {
        const newItem = {...item, children: []};
        result.push(newItem);
        turnTresData(data, newItem.children, item.number);
      }
    }
  }

  const convert = (data:any) => {
    const obj: Record<any,any> = {}
    data.values && data.values.forEach((item:any) => {
      obj[item.name] = item.value
    })
    return obj
  }

  const changeTreeType = (val:string) => {
    setTreeType(val)
    if (val === '组织') {
      getDepList()
    } else {
      getPostList()
    }
  }

  const getDepList = () => {
    getModuleRecordList(
      FetchAPI, 'master_data', 'md_operate_organize',
      {
        moduleID: 'md_operate_organize',
        namespaceID: 'master_data',
      }
    ).then(res => {
      const { set = [] } = res || {}
      const convertData = set.map((r:any) => convert(r))
      const treeData:any[] = [];
      turnTresData(convertData, treeData, '1')
      const resData = setMenuData(treeData)
      setTreeData(resData)
    })
  }

  const getPostList = () => {
    getModuleRecordList(
      FetchAPI, 'master_data', 'md_job_information',
      {
        moduleID: 'md_job_information',
        namespaceID: 'master_data',
      }
    ).then(res => {
      const { set = [] } = res || {}
      let convertData = set.map((r:any) => convert(r))
      convertData = convertData.map((item:any) => {
        return {
          label: item.position_name,
          key: item.position_no,
        }
      })
      setTreeData(convertData)
    })
  }
  
  useEffect(() => {
    getDepList()
  }, []);
  
  return {
    depTreeData,
    changeTreeType,
    treeType,
  };
};
